// extracted by mini-css-extract-plugin
export default {"ctn":"amount-card_ctn__6HhJZ","text":"amount-card_text__93zVo","title":"amount-card_title__iCyBI","revenue":"amount-card_revenue__5+tod"};